import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/organization/$slug/overview")({
  component: Overview,
});

function Overview() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-primary-darker">Overview</h1>
      <p className="mt-2 text-gray-500">Your organization at a glance.</p>
    </div>
  );
}
